module.exports = __webpack_public_path__ + "files/be979853dbdb26990e04c96c12332e18.png";